module.exports = __webpack_public_path__ + "media/voiture.3937dd31.mp4";